import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class ContactsAdminService extends BaseService<any> {
  constructor() {
    super(`contacts`);
  }

  getContactCounts = async (queryParams: object = {}) => {
    return appAxios.get(`${this.pathWithOrg()}/counts`, { params: queryParams });
  }
}

export default new ContactsAdminService();
